import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import useWindowSize from '../../utils/useWindowSize';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

function ActivityChart({ activityData, customAccentColor, customTextColor, customGridColor }) {
  const { width } = useWindowSize();
  const isMobile = width < 768;

  const textColor = customTextColor || getComputedStyle(document.documentElement).getPropertyValue('--text-secondary').trim();
  const accentColor = customAccentColor || getComputedStyle(document.documentElement).getPropertyValue('--accent').trim();
  const gridColor = customGridColor || getComputedStyle(document.documentElement).getPropertyValue('--border-color').trim();
  
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: { display: false },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        titleFont: { size: isMobile ? 12 : 14, weight: 'bold' },
        bodyFont: { size: isMobile ? 10 : 12 },
        padding: 8,
        cornerRadius: 6,
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { color: textColor, stepSize: 1, font: { family: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" } },
        grid: { color: gridColor },
      },
      x: {
        ticks: { color: textColor, font: { family: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" } },
        grid: { display: false },
      },
    },
    elements: {
      line: {
        tension: 0.4,
      }
    }
  };

  const data = {
    labels: activityData.map((item) => {
      // --- CAMBIO CLAVE: ESTA LÍNEA OCULTA TODOS LOS NÚMEROS EN MÓVIL ---
      if (isMobile) {
        return ''; // Devuelve un texto vacío para cada etiqueta en móvil
      }
      return item.date; // Muestra la fecha en escritorio
    }),
    datasets: [
      {
        label: 'Ejercicios',
        data: activityData.map(item => item.count),
        fill: false,
        backgroundColor: accentColor, 
        borderColor: accentColor,
        pointBackgroundColor: accentColor,
        pointBorderColor: '#000000',
        pointHoverRadius: 10,
        pointHoverBackgroundColor: '#ff0101',
        pointHoverBorderColor: '#000000',
        pointRadius: isMobile ? 3 : 5,
        borderWidth: 2,
      },
    ],
  };

  return <Line options={options} data={data} />;
}

export default ActivityChart;